import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useState } from "react";
import { ContentPartFilter } from "../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../components/page-header";
import { EntProductsFilter } from "../../../models/filters/productsFilter";
import { EntProduct } from "../../../models/product";
import { useProducts } from "./useProducts";
import { FilterPoducts } from "./FilterProducts";
import { AddProductModal } from "./AddProductModal";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetProductListQuery } from "../../../redux/api/products/productsApi";
enum FormField {
  productTypeIds,
  directionId,
  areaId,
  regionId,
  productionCountFrom,
  productionCountTo,
  salesCountFrom,
  salesCountTo,
  createdFrom,
  createdTo,
  deleted
}


export const Products = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedProduct, setSelectedProduct] = useState<EntProduct>(new EntProduct());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const {t} = useTranslation()

  const [getArchiveFolders] = useLazyGetProductListQuery();
  const {
    filter,
    fetching,
    data,
    totalItems,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntProduct, EntProductsFilter>({
    initialFilter: new EntProductsFilter(),
    query: getArchiveFolders
  });

  const { onAddProduct, onEditProduct, onDeleteProduct } = useProducts(modal, () => { searchHandleClick(); })
  const [height, setHeight] = useState<number>(0);
  const openAddModal = (item: EntProduct) => {
    setSelectedProduct(item);
    setShowModal(true);
  }
  const setEntityFromFields = (): EntProductsFilter => {
    let filt: EntProductsFilter = _.clone(filter);
    filt.productTypeIds = form.getFieldValue(FormField.productTypeIds) ?? null;
    filt.directionId = form.getFieldValue(FormField.directionId) ?? null;
    filt.areaId = form.getFieldValue(FormField.areaId) ?? null;
    filt.regionId = form.getFieldValue(FormField.areaId) ?? null;
    filt.productionCountFrom = form.getFieldValue(FormField.productionCountFrom) ?? null;
    filt.productionCountTo = form.getFieldValue(FormField.productionCountTo) ?? null;
    filt.salesCountFrom = form.getFieldValue(FormField.salesCountFrom) ?? null;
    filt.salesCountTo = form.getFieldValue(FormField.salesCountTo) ?? null;

    filt.deleted = form.getFieldValue(FormField.deleted) ?? false;
    return filt;
  }
  const clearFields = () => {
    form.setFields([
      { name: FormField.productTypeIds, value: null },
      { name: FormField.directionId, value: null },
      { name: FormField.areaId, value: null },
      { name: FormField.productionCountFrom, value: null },
      { name: FormField.productionCountTo, value: null },
      { name: FormField.salesCountFrom, value: null },
      { name: FormField.salesCountTo, value: null },
    
      { name: FormField.deleted, value: false },
      { name: FormField.regionId, value: null },
    ]);
  }
  const searchHandleClick = () => {
    setFilter(setEntityFromFields());
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const table = (
    <div style={{ maxHeight: `${height}px`, overflow: 'auto' }} onScroll={scrollHandler}>
      <table>
        <thead>
          <tr>
            <th style={{ width: "40px" }}>#</th>
            <th>{ t('handbooks.regions.region') }</th>
            <th>{t('product.product_type')}</th>
            <th>{ t('product.quantity_of_products_produced') }</th>
            <th>{ t('product.number_of_sales') }</th>
            <th style={{ width: "120px" }}></th>
          </tr>
        </thead>
        <tbody>
          {fetching ?
            <tr>
              <th colSpan={5}>
                <Spin spinning={fetching} style={{
                  width: '100%',
                  height: '180px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }} />
              </th>
            </tr>
            : <></>}
          {data.map((item, index) => (
            <tr key={item.id}>
              <td>{++index}</td>
              <td>{item?.area?.nameKy}</td>
              <td>
                {item?.productsTypes !== null ? (
                  item.productsTypes.map((productType, index) => (
                    <div key={index}>
                      <p>{productType.nameRu},</p>
                    </div>
                  ))
                ) : ""}
              </td>
              <td>{item?.countProduction}</td>
              <td>{item?.countSales}</td>
            
              <td>
                <Flex gap="small">
                  <Tooltip title={t('general.edit')}>
                    <Button className='btn_edit' onClick={() => { openAddModal(item) }} type="primary" shape="circle" icon={<EditOutlined />} />
                  </Tooltip>
                  <Tooltip title={ t('general.delete') }>
                    <Button className='btn_edit' danger onClick={() => { onDeleteProduct(item) }} type="primary" shape="circle" icon={<DeleteOutlined />} />
                  </Tooltip>
                </Flex>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
  return (
    <>
      <PageHeader
        title={t('titles.register_of_productions')}
        additionalInfo={
          <Typography.Text style={{ marginBottom: '0.5em', display: 'block' }} type="secondary">
            {t('product.register_of_productions_desc')}{t('general.records_found')} {totalItems}</Typography.Text>
        } />
      <Button type="primary" icon={<PlusOutlined />} onClick={() => { openAddModal(new EntProduct) }}>
        {t('product.add_register_of_productions')}
      </Button>
      <ContentPartFilter
        filter={<FilterPoducts   onSearch={searchHandleClick}
        onReset={() => { clearFields(); searchHandleClick() }} formField={FormField} form={form} />}
        setHeight={setHeight}
        table={table}
      />
      <AddProductModal
        product={selectedProduct}
        show={showModal}
        onHide={() => {
          setShowModal(false)
        }}
        onSubmit={selectedProduct.id !== 0 ? onEditProduct : onAddProduct}
      />
      {contextHolder}
    </>
  )
}
